import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer style={{ borderTop: '1px solid var(--border)', background: 'var(--canvas)' }}>
      <div className="container-site" style={{ padding: '64px 40px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 48, marginBottom: 56 }}>
          {/* Brand */}
          <div>
            <div style={{ marginBottom: 16 }}>
              <span className="font-grotesk" style={{ fontSize: 15, fontWeight: 700, letterSpacing: '-0.02em' }}>Outbox</span>
              <span className="font-mono" style={{ fontSize: 11, color: 'var(--accent)', marginLeft: 6 }}>Thinking</span>
            </div>
            <p className="body-base" style={{ fontSize: 13, color: 'var(--ink-500)', maxWidth: 220 }}>
              UX-driven digital experiences for startups and enterprises.
            </p>
          </div>

          {/* Nav */}
          <div>
            <p className="label-sm" style={{ marginBottom: 16 }}>Navigation</p>
            {[['/', 'Home'], ['/services', 'Services'], ['/case-studies', 'Work'], ['/about', 'About'], ['/contact', 'Contact']].map(([p, l]) => (
              <Link key={p} to={p} style={{ display: 'block', marginBottom: 8, fontSize: 13, color: 'var(--ink-500)', textDecoration: 'none', fontFamily: 'Inter, sans-serif' }}
                onMouseEnter={e => e.target.style.color = 'var(--ink-950)'}
                onMouseLeave={e => e.target.style.color = 'var(--ink-500)'}
              >
                {l}
              </Link>
            ))}
          </div>

          {/* Contact */}
          <div>
            <p className="label-sm" style={{ marginBottom: 16 }}>Contact</p>
            <a
              href="mailto:hngdigital2025@gmail.com"
              style={{ fontSize: 13, color: 'var(--ink-500)', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 4, fontFamily: 'Inter, sans-serif' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--ink-950)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--ink-500)'}
              data-testid="footer-email"
            >
              hngdigital2025@gmail.com <ArrowUpRight size={13} />
            </a>
            <Link to="/contact" data-testid="footer-cta"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 20, padding: '8px 16px', border: '1px solid var(--border)', borderRadius: 6, fontSize: 12, color: 'var(--ink-950)', textDecoration: 'none', fontFamily: 'Inter, sans-serif', fontWeight: 500 }}
              onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--ink-500)'}
              onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}
            >
              Start a Project <ArrowUpRight size={12} />
            </Link>
          </div>
        </div>

        <div className="divider" style={{ marginBottom: 24 }} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <span className="font-mono" style={{ fontSize: 11, color: 'var(--ink-300)', letterSpacing: '0.06em' }}>
            &copy; {year} OUTBOX THINKING
          </span>
          <span className="font-mono" style={{ fontSize: 11, color: 'var(--ink-300)', letterSpacing: '0.06em' }}>
            DESIGN &middot; STRATEGY &middot; PRODUCT
          </span>
        </div>
      </div>
    </footer>
  );
};
